import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import ContactNameModel from "../../ContactSelector/models/ContactNameModel";
import { ContactInputModel } from "../models/ContactInputModel";
import ContactModel from "../models/ContactModel";
import ContactQueryModel from "../models/ContactQueryModel";
import ContactStaticResourcesModel from "../models/ContactStaticResourcesModel";

export interface SearchContactParam {
    pageSize: number,
    query: ContactQueryModel
}

export interface GetContactByIdParam {
    id: string,
}

export interface DeleteContactByIdParam {
    id: string,
}
export interface SearchContactNameParam {
    keyword: string,
}

const ContactApi = {
    SearchContactName(param: SearchContactNameParam) {
        return Api.get<SearchContactNameParam, BaseResponse<ContactNameModel[]>>("/api/contact/SearchContactName", param);
    },
    Search(param: SearchContactParam) {
        return Api.post<SearchContactParam, BaseResponse<ContactModel[]>>("/api/contact/Search", param);
    },
    Save(param: ContactInputModel) {
        return Api.post<ContactInputModel, BaseResponse<ContactModel>>("/api/contact/Save", param);
    },
    GetById(param: GetContactByIdParam) {
        return Api.get<GetContactByIdParam, BaseResponse<ContactModel>>("/api/contact/GetById", param);
    },
    GetStaticResources() {
        return Api.get<unknown, BaseResponse<ContactStaticResourcesModel>>("/api/contact/GetStaticResources", null);
    },
    Delete(param: DeleteContactByIdParam) {
        return Api.post<DeleteContactByIdParam, BaseResponse<ContactModel>>("/api/contact/Delete", param);
    },
};
export default ContactApi;